module.exports = window.wp.priorityQueue;